export const ValidRoutes = {
  Root: [
    "campaign-management",
    "mobilisation-management",
    "campaign-detail",
    "create-advert",
    "advert-detail",
    "advert-tracker",
    "applicant-profile",
    "user-management",
    "subscription-management",
    "news-feed",
    "report-builder",
    "archive",
    "search",
    "chats",
    "myProfile",
    "edit-profile",
    "onboarding",
    "create-account",
    "404",
  ],
  Admin: [
    "campaign-management",
    "mobilisation-management",
    "campaign-detail",
    "create-advert",
    "advert-detail",
    "advert-tracker",
    "applicant-profile",
    "user-management",
    "subscription-management",
    "news-feed",
    "report-builder",
    "archive",
    "search",
    "chats",
    "myProfile",
    "edit-profile",
    "onboarding",
    "create-account",
    "404",
  ],
  Associate: [
    "job-advert",
    "create-advert",
    "advert-detail",
    "advert-tracker",
    "applicant-profile",
    "news-feed",
    "report-builder",
    "search",
    "chats",
    "myProfile",
    "edit-profile",
    "onboarding",
    "create-account",
    "404",
  ],
  Account: [
    "campaign-management",
    "mobilisation-management",
    "campaign-detail",
    "create-advert",
    "advert-detail",
    "advert-tracker",
    "applicant-profile",
    "user-management",
    "news-feed",
    "report-builder",
    "archive",
    "search",
    "chats",
    "myProfile",
    "edit-profile",
    "onboarding",
    "create-account",
    "404",
  ],
  AccountCampaign: [
    "campaign-management",
    "mobilisation-management",
    "campaign-detail",
    "create-advert",
    "advert-detail",
    "applicant-profile",
    "advert-tracker",
    "news-feed",
    "report-builder",
    "archive",
    "search",
    "chats",
    "myProfile",
    "edit-profile",
    "onboarding",
    "create-account",
    "404",
  ],
  AccountUser: [
    "user-management",
    "applicant-profile",
    "news-feed",
    "archive",
    "search",
    "chats",
    "myProfile",
    "edit-profile",
    "onboarding",
    "create-account",
    "404",
  ],
};
